/**
 * WhatsApp utility — единая точка для открытия WhatsApp ссылок с аналитикой.
 *
 * Вместо копипасты "cleanNumber + wa.me + window.open" в каждом компоненте,
 * все вызовы проходят через openWhatsApp(). Это гарантирует:
 * - Трекинг каждого клика (dataLayer + gtag + beacon)
 * - Единый формат URL
 * - Одно место для изменений
 */

import { trackWhatsAppClick } from '../services/analyticsBridge';
import { emitWhatsAppCarClick } from '../services/carEngagementEvents';

/**
 * Open WhatsApp chat with tracking.
 *
 * @param {Object} params
 * @param {string} params.phone - Phone number (any format, cleaned automatically)
 * @param {string} [params.message] - Pre-filled message
 * @param {string} [params.context] - Where the click happened (e.g. 'car_card', 'contact_page')
 * @returns {boolean} true if opened, false if phone was missing
 */
export function openWhatsApp({ phone, message, context }) {
  if (!phone) {
    console.error('[WhatsApp] Phone number not provided');
    return false;
  }

  const cleanNumber = phone.replace(/\D/g, '');
  const url = message
    ? `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${cleanNumber}`;

  trackWhatsAppClick({ whatsappUrl: url, context });
  // Per-car attribution for the Insights funnel (#970) — fires only when a car
  // is on screen (no-op otherwise).
  emitWhatsAppCarClick();
  window.open(url, '_blank');
  return true;
}
